export default __webpack_public_path__ + "static/media/arrow-up.a94f819c.svg";